import { setUser } from 'src/common/sentry-client'

export function sentrySetUser(user) {
  if (!user) {
    setUser(null)
    return
  }

  setUser({ username: user.username, email: user.email, id: user.id })
}
